// 下载附件 方法1
export async function downloadFile(url, name) {
  const response = await fetch(url);
  // 内容转变成blob地址
  const blob = await response.blob();
  // 创建隐藏的可下载链接
  const objectUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  // 地址
  a.href = objectUrl;
  // 修改文件名
  a.download = name;
  // 触发点击
  document.body.appendChild(a);
  a.click();
  // 移除
  setTimeout(() => document.body.removeChild(a), 1000);
}
